<template>
	<table class="list_tbl sticky_list_tbl" v-columns-resizable>
		<colgroup>
			<col style="width: 3%;" />
			<col style="width: 4%;" />
			<col style="width: 5%;" />
			<col style="width: 8%;" />
			<col style="width: 5%;" />
			<col style="width: 14%;" />
			<col style="width: 3%;" />
			<col style="width: 6%;" />
			<col style="width: 6%;" />
			<col style="width: 6%;" />
			<col style="width: 6%;" />
			<col style="width: 6%;" />
			<col style="width: 7%;" />
			<col style="width: 5%;" />
			<col />
		</colgroup>
		<thead>
			<tr>
				<th>No</th>
				<th>Receipt Type</th>
				<th>
					<a href="javascript:void(0);" @click="sort('valid_receipt_date')">Valid Receipt Date{{ sort_mark('valid_receipt_date') }}</a>
				</th>
				<th>Sales Grp</th>
				<th>
					<a href="javascript:void(0);" @click="sort('bill_to')">Bill To{{ sort_mark('bill_to') }}</a>
				</th>
				<th>Bill To Name</th>
				<th>STATE</th>
				<th>
					<a href="javascript:void(0);" @click="sort('receipt_amt')">Receipt Amt{{ sort_mark('receipt_amt') }}</a>
				</th>
				<th>Billing No</th>
				<th>Invoice Amt</th>
				<th>AR Amount</th>
				<th>Check No</th>
				<th>Payment Term</th>
				<th>Past Due Date</th>
				<th>Receipt<br />Remarks</th>
			</tr>
		</thead>
		<tbody>
			<template v-for="(type, typeIndex) in root">
				<tr v-bind:key="typeIndex">
					<td colspan="15" class="al_left">{{ type.receipt_type_code }} {{ type.receipt_type_name }}</td>
				</tr>
				<template v-for="(date, dateIndex) in type.receiptTypeDateList">
					<template v-for="(bill, billIndex) in date.billList">
						<tr v-for="(invoice, invoiceIndex) in bill.receiptItemList" v-bind:key="`${dateIndex}-${billIndex}-${typeIndex}-${invoiceIndex}`">
							<td class="al_center">{{ invoice.index }}</td>
							<td class="al_center">{{ type.receipt_type_code }}</td>

							<template v-if="invoiceIndex === 0 || (invoiceIndex > 0 && invoice.receipt_item_no !== bill.receiptItemList[invoiceIndex - 1].receipt_item_no)">
								<td class="al_center">{{ date.valid_receipt_date }}</td>
								<td class="al_left">{{ bill.sales_group_name }}</td>
								<td class="al_left">{{ bill.bill_to_code }}</td>
								<td class="al_left">{{ bill.bill_to_name }}</td>
								<td class="al_center">{{ bill.bill_address_state }}</td>
								<!-- bill.receipt_amount는 bill.receiptItemList 각 요소를 receipt_item_no로 그룹핑했을 때, 각 그룹에 해당하는 receipt_item_amount의 합임.(java service에서 계산) -->
								<!-- 단, 한 receipt데이터를 type이 같은 receipt_item데이터가 참조하는 경우는 거의 없으므로(위 그룹핑 결과, 거의 그룹이 1개임.) -->
								<!-- bill.receipt_amount를 receipt_item의 amount로 볼 수 있음. (단, Check같은 경우 1개의 receipt데이터를 type이 같은 receipt_item데이터가 참조할 수 있음.)  -->
								<td class="al_right">{{ invoice.receipt_item_amount | toCurrencyZeroNull }}</td>
							</template>
							<template v-else>
								<td colspan="6"></td>
							</template>

							<td class="al_right">{{ invoice.invoice_dn }}</td>
							<td class="al_right">{{ invoice.invoice_amount | toCurrency }}</td>
							<td class="al_right">{{ invoice.ar_amount | toCurrencyZeroNull }}</td>
							<td class="al_left">{{ invoice.check_no }}</td>
							<td class="al_center">{{ invoice.payment_term_name }}</td>
							<td class="al_right">{{ invoice.past_due_date | commaSeparated }}</td>
							<td class="al_left">
								<template v-if="viewReceiptRemark">
									<template v-if="['ACH', 'PACH'].includes(type.receipt_type_code)">{{ bill.bank_info }}</template>
									<template v-else-if="['PCC', 'CC', 'U6'].includes(type.receipt_type_code)">{{ bill.card_info }}</template>
									<template v-else>{{ invoice.receipt_remark }}</template>
								</template>
								<template v-else>{{ invoice.receipt_remark }}</template>
							</td>
						</tr>
					</template>
				</template>
				<tr v-bind:key="`${typeIndex}/sub`">
					<td colspan="7" class="al_right">Sub Total</td>
					<td class="al_right">{{ type.total_amount | toCurrency }}</td>
					<td colspan="7"></td>
				</tr>
			</template>
			<tr>
				<td colspan="7" class="al_right">Grand Total</td>
				<td class="al_right">{{ grandTotal | toCurrency }}</td>
				<td colspan="7"></td>
			</tr>
		</tbody>
	</table>
</template>
<script>
export default {
	name: 'dataTable',
	props: {
		grandTotal: {},
		root: {},
		viewReceiptRemark: {
			type: Boolean,
			default: false,
		},
		sortKey: {
			type: String,
			default: '',
		},
		sortDirection: {
			type: String,
			default: '',
		},
	},

	methods: {
		sort(keyword) {
			this.$emit('sort', keyword);
		},

		sort_mark(keyword) {
			if (this.sortKey === keyword) {
				return this.sortDirection === 'ASC' ? '▲' : '▼';
			}
		},
	},
};
</script>
